import { render, staticRenderFns } from "./ServiceBanner.vue?vue&type=template&id=fadda128&scoped=true"
import script from "./ServiceBanner.vue?vue&type=script&lang=js"
export * from "./ServiceBanner.vue?vue&type=script&lang=js"
import style0 from "./ServiceBanner.vue?vue&type=style&index=0&id=fadda128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadda128",
  null
  
)

export default component.exports